﻿import { useNavigate } from "react-router-dom";

import classes from "../maintainers.module.scss";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";
import CustomBadge from "@/components/desktop/badge/CustomBadge";

const VersionsTableBody = ({ versions, handleDelete }) => {
	const navigate = useNavigate();

	return (
		<tbody>
			{versions &&
				versions.map((item, i) => {
					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{i + 1}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} `}>{item.version}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									{item.stable && <CustomBadge variant="success">Estable</CustomBadge>}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div}`} style={{ fontSize: "11px" }}>
									{item.git_restoration_point_driver}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} `} style={{ fontSize: "11px" }}>
									{item.git_restoration_point_app}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>{item.customers && item.customers.length}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									{item.active ? <CustomBadge variant="success">Activo</CustomBadge> : <CustomBadge variant="warning">Inactivo</CustomBadge>}
								</div>
							</td>

							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									<PencilSvg className={classes.icon} onClick={() => navigate("/mantenedores/versiones/editar/" + item.id)} />
									<RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default VersionsTableBody;
